import React from 'react';
import { FaGithub } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import "swiper/components/effect-coverflow/effect-coverflow.min.css";
import "swiper/components/pagination/pagination.min.css";
// Import Swiper styles
import "swiper/swiper.min.css";

const PortfolioDetails = ({ data }) => {
    const { title } = useParams();

    if (data) {
        var projectData = data.filter(item => item.title === title);
        console.log(projectData)
    }
    return (
        <section className="my-24 max-w-screen-xl mx-auto px-6">
            <div className="flex justify-center">
                <h1 className="text-center text-4xl lg:text-7xl">{projectData[0]?.title}</h1>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-1 gap-10 mt-12">
                {/* image  */}
                <div>
                    
                    <img className="object-cover rounded-xl w-full h-full" src={projectData[0]?.image} alt={projectData[0]?.title} />
                           

                </div>

                {/* description  */}
                <div className="bg-white flex flex-col mx-auto justify-center w-full p-8 rounded-xl shadow-xl box-border">
                    <h1 className="portfolio-description-heading">Project Description</h1>
                    <div className="flex flex-col py-4 pt-4 space-y-3">
                        {projectData[0]?.description}
                    </div>
                    <div className="flex flex-col py-1 space-y-3">
                        Technologies: {projectData[0]?.technologies}
                    </div>

                    <div className="flex items-center space-x-4">
                        <a className="link-live-demo" href={projectData[0]?.liveLink} target="_blank" rel="noreferrer">
                            <button className="bg-primary px-5 py-3 rounded-lg shadow-xl my-7 text-white font-bold">
                                Live Demo
                            </button>
                        </a>
    

                        <a className="github_icon" href={projectData[0]?.githubLink} target="_blank" rel="noreferrer">
                            <FaGithub className="text-5xl" />
                        </a>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default PortfolioDetails
